module.exports = "<div class=\"rich-text-container\"\n     ng-class=\"{'disabled': $ctrl.readOnly}\">\n  <div id=\"quill-editor\" class=\"rich-text-editor\"\n       ng-style=\"{'height': $ctrl.rtHeight || '200px'}\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/components/so-rich-text-box/so-angular-quill-js/so-angular-quill-js.component.html
// module id = 447
// module chunks = 0